var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_1726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.55521 3.83086C11.773 -1.27956 20.2353 -1.27956 25.453 3.83086L26.0805 4.4418C26.3447 4.69774 26.3447 5.11053 26.0805 5.36647L23.934 7.47173C23.8019 7.59557 23.5955 7.59557 23.4634 7.47173L22.5965 6.62137C18.9556 3.05481 13.0526 3.05481 9.41177 6.62137L8.4871 7.52952C8.35501 7.65336 8.14861 7.65336 8.01651 7.52952L5.86171 5.43252C5.59752 5.17658 5.59752 4.76379 5.86171 4.50785L6.55521 3.83086ZM29.8947 8.18174L31.8101 10.0558C32.0743 10.3118 32.0743 10.7246 31.8101 10.9805L23.1827 19.4263C22.9185 19.6823 22.4974 19.6823 22.2415 19.4263L16.1238 13.4325C16.0578 13.3665 15.9505 13.3665 15.8844 13.4325L9.76677 19.4263C9.50258 19.6823 9.08153 19.6823 8.82559 19.4263L0.198142 10.9805C-0.0660475 10.7246 -0.0660475 10.3118 0.198142 10.0558L2.11352 8.18174C2.37771 7.92581 2.79876 7.92581 3.0547 8.18174L9.17234 14.1756C9.23839 14.2416 9.34572 14.2416 9.41177 14.1756L15.5294 8.18174C15.7936 7.92581 16.2147 7.92581 16.4706 8.18174L22.5882 14.1756C22.6543 14.2416 22.7616 14.2416 22.8277 14.1756L28.9453 8.18174C29.2095 7.92581 29.6305 7.92581 29.8947 8.18174Z",
    fill: "#3B99FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_1726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 19.6161,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.a104d1bd616a4beb70d08648a79bcb29.svg";
export { ForwardRef as ReactComponent };